<div #main class="main" [ngClass]="{ active: currentStep!==undefined}" (click)="onClick();">
  <div class="masker">
  </div>
  <div class="text" [ngClass]="{ visible: textVisible===true}">
    <p>{{currentMessage}}</p>
  </div>
</div>